import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-protection-juridique',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-protection-juridique.component.html',
  styleUrls: ['./assurance-protection-juridique.component.scss']
})
export class AssuranceProtectionJuridiqueComponent {
  title = 'Assurance Protection Juridique';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/protection-juridique.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Protection Juridique', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Loyers Impayés',
    link: '/assurance-loyers-impayes'
  };

  nextPage = { 
    title: 'Assurance Œuvres d\'Art - Bijoux',
    link: '/assurance-oeuvres-art-bijoux'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
